import { phoneDigitsNational } from "./wicoopProfileStorage.js";

export function phoneProofStorageKey(giveawayId, phoneNational) {
  const ph = String(phoneNational || "").replace(/\D/g, "");
  return `wicoop_phone_proof_v1_${giveawayId}_${ph}`;
}

export function savePhoneProofForGiveaway(giveawayId, phoneNational, proofUuid) {
  localStorage.setItem(phoneProofStorageKey(giveawayId, phoneNational), String(proofUuid));
}

export function readPhoneProofForGiveaway(giveawayId, phoneNational) {
  return localStorage.getItem(phoneProofStorageKey(giveawayId, phoneNational)) || null;
}

export { phoneDigitsNational };
